import React from "react";
import { useNavigate } from "react-router-dom";

const cars = [
  {
    brand: "maruti",
    name: "Maruti Suzuki Dzire",
    image: "/images/fleet/dsire.jpg",
    location: "Mumbai",
    price: "₹12 / KM",
    rating: "4.5",
    reviews: "210",
  },
  {
    brand: "maruti",
    name: "Maruti Suzuki Ertiga",
    image: "/images/fleet/ertiga.jpg",
    location: "Mumbai",
    price: "₹15 / KM",
    rating: "4.6",
    reviews: "185",
  },
  {
    brand: "toyota",
    name: "Toyota Innova Crysta",
    image: "/images/fleet/innova-crysta.jpg",
    location: "Mumbai",
    price: "₹18 / KM",
    rating: "4.8",
    reviews: "250",
  }
];

const PopularCarss = () => {

  const navigate = useNavigate();

  const handleBooking = () => {
    navigate("/booking");
  };

  return (
    <section className="section popular-services popular-explore">
      <div className="container">

        <div className="section-heading">
          <h2>Explore Most Popular Cars</h2>
          <p>
            Here are some popular cars used by Omshreee Cabs, trusted for smooth and safe rides.
          </p>
        </div>

        <div className="row mt-4 ">
          {cars.map((car, index) => (
            <div className="col-lg-4 col-md-6 col-12 " key={index}>
              <div className="listing-item borderr">

                <div className="listing-img">
                  <img src={car.image} className="img-fluid" alt={car.name} />
                  {/* <span className="featured-text">{car.brand}</span> */}
                </div>

                <div className="listing-content borderr">
                  <h3 className="listing-title text-center">{car.name}</h3>

                  <div className="list-rating text-center">
                    ⭐⭐⭐⭐⭐ <span>({car.rating}) {car.reviews} Reviews</span>
                  </div>
{/* 
☆
                  <div className="listing-location-details">
                    <div className="listing-price">
                      {car.location}
                    </div>

                    <div className="listing-price">
                      <h6>{car.price}</h6>
                    </div>
                  </div> */}

                  <div className="listing-button">
                    <button className="btn btn-order" onClick={handleBooking}>
                      Book Now
                    </button>
                  </div>

                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PopularCarss;